export default __webpack_public_path__ + "static/media/default.d933c552.png";